import React from 'react';
import PropTypes from 'prop-types';
import { ButtonWithIcon } from '@els/els-react--button';

// FR-1.7: four skeleton lines (three full-width, one half-width) reusing the existing
// `c-els-loader-shimmer` Leyden core class already used here — no new component or animation.
// FR-1.9: the loading action becomes a labelled Leyden Stop control.
function SummaryLoading({ buttonRef, onCancel }) {
  return (
    <div className="ai-search-summary__loading" data-testid="summary-loading">
      <div className="ai-search-summary__loading-line c-els-loader-shimmer u-els-margin-bottom-1o2" />
      <div className="ai-search-summary__loading-line c-els-loader-shimmer u-els-margin-bottom-1o2" />
      <div className="ai-search-summary__loading-line c-els-loader-shimmer u-els-margin-bottom-1o2" />
      <div className="ai-search-summary__loading-line u-els-width-1o2 c-els-loader-shimmer u-els-margin-bottom-1x1o2" />
      <div className="ai-search-summary__loading-actions u-els-display-flex">
        <ButtonWithIcon
          ref={buttonRef}
          type="primary"
          size="small"
          sprite="Stop"
          onClick={onCancel}
          data-e2e="stop-summary-generation-button">
          Stop generating
        </ButtonWithIcon>
      </div>
    </div>
  );
}

SummaryLoading.propTypes = {
  buttonRef: PropTypes.oneOfType([PropTypes.func, PropTypes.shape({ current: PropTypes.any })]),
  onCancel: PropTypes.func.isRequired,
};

export default SummaryLoading;
